import React, { useState } from 'react';
import InlineSelect from '../../../Elements/InputComponents/BaseInputs/InlineSelect';

const dayOptions = [
  { value: 7, label: 'by the 7th' },
  { value: 14, label: 'by the 14th' },
  { value: null, label: 'whenever it is ready' },
];

function InlineSelectDemoComponent() {
  const [day, setDay] = useState(7);

  return (
    <div>
      <p style={{ fontSize: 14, lineHeight: 2.4 }}>
        The draft is checked{' '}
        <InlineSelect
          value={day}
          options={dayOptions}
          label='When the draft is checked'
          onChange={setDay}
        />
        .
      </p>
      <p style={{ fontSize: 13, color: 'var(--ink-2)' }}>Picked value: {day === null ? 'null' : day}</p>
    </div>
  );
}

export const inlineSelectDemo = {
  id: 'inline-select',
  title: 'Inline select',
  category: 'Inputs',
  importPath: 'Elements/InputComponents/BaseInputs/InlineSelect',
  notes: [
    'A choice inside a sentence: a native select in bold navy, as wide as its longest choice.',
    'options are { value, label }. onChange gets the picked option’s own value, so a number or null stays one (try the third choice).',
    'label names the choice for screen readers. Not an InputTypesEnum type: use it in sentences, such as SettingRows.',
  ],
  snippet:
    '<InlineSelect\n  value={day}\n  options={[{ value: 7, label: "by the 7th" }, { value: 14, label: "by the 14th" }]}\n  label="When the draft is checked"\n  onChange={setDay}\n/>',
  render: InlineSelectDemoComponent,
};
